import React from "react";
import "../../App.css";
import HeroSection from "../HeroSection";
import Cards from "../Cards";
import Footer from "../Footer";
import Banner from "../Banner";
import CardServices from "../CardServices";
import CardPortfolio from "../CardPortfolio";
import Cta from "../Cta";

function Home() {
  return (
    <>
      <HeroSection />
      <Banner text="Your Property. Your Story. Captured in Every Angle." />
      <Cards />
      <CardServices/>
      <CardPortfolio/>
      <Cta headline="TRANSFORM YOUR PROPERTY'S APPEAL" subtext="and give potential buyers a reason to say yes faster." buttonLink="./contact"buttonText="Contact us"/>
      <Footer />
    </>
  );
}

export default Home;
